module.exports = __webpack_public_path__ + "static/media/tavernello-castellino.4d8c0827.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tavernello-castellino.jpg
// module id = 816
// module chunks = 0